import * as React from "react";

import { Modal } from "@material-ui/core";
import { SecondaryButton } from "Components/Shared/Buttons/SecondaryButton";
import styled from "styled-components";

type Props = {
  alt: string;
  imageUrl: string;
  open: boolean;
  onClose: () => void;
};

const StyledWrapperModal = styled(Modal)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  & > div {
    &:first-of-type {
      background-color: rgba(255, 255, 255, 0.8) !important;
    }
  }

  .modal-body {
    outline: none;
    width: 100%;
    height: 100%;
    margin: auto;

    @media (max-width: 1199px) {
      max-width: calc(100% - 20px);
    }
  }

  .modal-body-content {
    outline: none;
    background-color: #fff;
    border: 1px solid ${props => props.theme.colors.border};
    box-shadow: ${props => props.theme.shadow.primary};
    width: 100%;
    height: 100%;
    margin: auto;
    position: relative;
    padding: 40px;
  }

  .modal-btns-block {
    > button {
      &:last-of-type {
        position: absolute;
        top: 5px;
        right: 5px;
        padding: 0;
        width: 30px;
        height: 30px;
        box-shadow: none;
        border: 0;
        margin-right: 0;

        &::after,
        &::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 20px;
          height: 2px;
          background-color: ${props => props.theme.palette.primary.main};
        }

        &::after {
          transform: rotate(45deg);
        }
        &::before {
          transform: rotate(-45deg);
        }
      }
    }
  }
`;

const StyledImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const StyledBody = styled.div`
  padding: 0;
  max-height: calc(100vh - 40px);
  outline: none !important;
  display: flex;
  flex-direction: column;
`;

const StyledBtnsWrapper = styled.div`
  display: flex;
  align-items: center;

  & > * {
    &:first-of-type {
      margin-right: ${props => props.theme.spacing(3)}px;
    }
  }
`;

export const AvatarModal: React.FunctionComponent<Props> = props => {
  const { alt, imageUrl, open, onClose } = props;

  const getUrl = () => imageUrl && imageUrl.replace("=s96", "=s1000");

  return (
    <StyledWrapperModal open={open} onClose={onClose}>
      <StyledBody className={"modal-wrapper"}>
        <div className="modal-body">
          <div className="modal-body-content">
            {imageUrl && (
              <StyledImageWrapper>
                <img src={getUrl()} alt={alt} />
              </StyledImageWrapper>
            )}

            <StyledBtnsWrapper className={"modal-btns-block"}>
              <SecondaryButton onClick={onClose}></SecondaryButton>
            </StyledBtnsWrapper>
          </div>
        </div>
      </StyledBody>
    </StyledWrapperModal>
  );
};
